// extracted by mini-css-extract-plugin
export var caseStudyVideo = "CaseStudyVideo--caseStudyVideo--nd9t3";
export var caseStudyVideo__image = "CaseStudyVideo--caseStudyVideo__image--OdDnV";
export var caseStudyVideo__image__icon = "CaseStudyVideo--caseStudyVideo__image__icon--KRzyt";
export var caseStudyVideo__video = "CaseStudyVideo--caseStudyVideo__video--zmpPN";
export var tkMyriadProSemiCondensed = "CaseStudyVideo--tk-myriad-pro-semi-condensed--NWY8k";